import AppSectionHeader from "./components/AppSectionHeader";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../context/appContext";
import LoadingDashboardContent from "../utils/loading/LoadingDashboardContent";
import AppFooter from "./components/AppFooter";
import LoggingOutDashboard from "../utils/loading/LoggingOutDashboard";

export const TemplatePage = ({ type, admins = [], users = [], children }) => {
  const theme = useTheme();
  const { isMobile, loading, loggingOut } = useAppContext();

  const APPBAR_HEIGHT = "4rem";
  const RIBBON_HEIGHT = isMobile ? "3rem" : "6rem";
  const FOOTER_HEIGHT = "2.5rem";

  if (loading) return <LoadingDashboardContent />;
  if (loggingOut) return <LoggingOutDashboard />;

  return (
    <div
      style={{
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ✅ FIXED PAGE HEADER */}
      {type !== "default" && (
        <div
          style={{
            position: "fixed",
            top: APPBAR_HEIGHT,
            left: 0,
            right: 0,
            height: RIBBON_HEIGHT,
            zIndex: 1000,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <AppSectionHeader type={type} admins={admins} users={users} />
        </div>
      )}

      {/* ✅ CONTENT SLOT */}
      <div
        style={{
          flex: 1,

          marginTop:
            type !== "default"
              ? `calc(${APPBAR_HEIGHT} + ${RIBBON_HEIGHT})`
              : 0,
          marginBottom: FOOTER_HEIGHT, // ✅ avoid footer overlap
          display: "flex",
          flexDirection: "column",
          minHeight: 0, // ✅ CRITICAL for proper flex scrolling
        }}
      >
        {children}
      </div>

      {/* ✅ FIXED FOOTER */}
      <AppFooter height={FOOTER_HEIGHT} />
    </div>
  );
};
